export default class OfferAgent {
    public static Create(obj: OfferAgent) {
        return Object.assign(new OfferAgent(), obj)
    }
    id: number = 0
    name: string = ''
}
